import { debounce } from 'lodash';
import { memo, useCallback } from 'react';

import { SearchIcon } from '@air/design-icons';
import { Input } from '@air/primitive-input';

export type BoardSelectSearchProps = {
  onChange: (search: string) => void;
};

export const BoardSelectSearch = memo(({ onChange }: BoardSelectSearchProps) => {
  /**
   * ESLint complains about passing inline function, but only this version works with debounce
   */
  // biome-ignore lint/style/noMagicNumbers lint/correctness/useExhaustiveDependencies: PLA-1724 — pre-existing debt, not introduced by the icon migration
  const debouncedOnChange = useCallback(debounce(onChange, 300), [onChange]);

  return (
    <div className="relative w-full">
      <SearchIcon className="absolute top-1/2 left-2 -translate-y-1/2 ads:text-icon-subtle text-gray-9" size="lg" />
      <Input
        className="w-full pl-10"
        data-testid="BOARD_SELECT_SEARCH_INPUT"
        // biome-ignore lint/performance/noJsxPropsBind: PLA-1724 — pre-existing debt, not introduced by the icon migration
        onChange={(event) => debouncedOnChange(event.target.value)}
        placeholder="Search workspace"
        size="large"
        type="search"
      />
    </div>
  );
});

BoardSelectSearch.displayName = 'BoardSelectSearch';
